
import { Injectable } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';

import { AjaxService } from '../../../services/ajax.service';
import { ViewScopeService } from '../../../services/view-scope.service';
import { DirectionService } from '../../../services/direction.service';

import { INDEX_HISTORY_LOAD, INDEX_HISTORY_ITEM_LOAD, INDEX_ASSIGNMENTS_PRINT, INDEX_POSTUPLOAD_REMARKS, INDEX_RELOAD_REQUEST } from '../../../services/account-api.constants'


export interface IndexHistoryItem {
	id: number;       						// RecID
	userName: string;  						// UserName
	importId: number; 						// Import_ID 
	Parent_Import_ID: number | null; 		// Parent Import ID - PII
	date: string;      						// DateEntered
	status: string;    						// IsActive
	details: string;   						// Descr
	code: 100 | 200;      					// Code (200 - Completed, 100 - Not Completed - just uploaded).
	stage: string; 	   						// Status
	fileSize: number;						// FileSizeByte
}


export interface IndexHistoryItemDetailed {
	id: number;        		// RecID
	importId: number; 		// Import_ID 
	fileName: string;  		// FileName
	folderName: string; 	// FolderName
	fileTypeId: string;		// FileTypeRecID
	indexTypeName: string; 	// FileIndexType
	status: string;    		// IsActive
	details: string;   		// Descr
	url: string; 			// URL
	fileSize: number;		// FileSizeByte
}

interface AssignedValuesItem
{
	IndexSectionRecID 	: number;
	SectionNumber?		: string;
	SectionName			: string; // SectionName_HE or SectionName_EN
}

@Injectable({ providedIn: 'root' })
export class IndexHistoryService {
	constructor(private ajaxService: AjaxService, private viewScopeService: ViewScopeService, private dirServ: DirectionService) {

	}

	public getAllUploades(): Observable<IndexHistoryItem[]> {
		const url = this.ajaxService.getBaseOfApi() + INDEX_HISTORY_LOAD + this.viewScopeService.getCurrentCustomer() + '/' + this.viewScopeService.getCurrentOpertaingUserId();
		return this.ajaxService.getData(url).pipe(map((response: any) => {

			return (response || []).map((item: any) => ({
				id: item.RecID,
				importId: item.Import_ID,
				Parent_Import_ID : item.Parent_Import_ID,
				date: item.DateEntered,
				status: item.IsActive,
				details: item.Descr,
				userName: item.UserName,
				code: item.Code,
				stage: item.Status,
				fileSize: item.FileSizeByte
			})) as IndexHistoryItem[];
		}),
			catchError(error => {
				console.error('Error fetching index history:', error);
				return of([]); // fallback: empty array
			}));
	}

	public getUploadDetails(importId: number): Observable<IndexHistoryItemDetailed[]> {
		const url = this.ajaxService.getBaseOfApi() + INDEX_HISTORY_ITEM_LOAD + this.viewScopeService.getCurrentCustomer() + '/' + importId + '/' + this.viewScopeService.getCurrentOpertaingUserId().toString();
		return this.ajaxService.getData(url).pipe(map((response: any) => {
			return (response || []).map((item: any) => ({
				id: item.RecID,
				importId: item.Import_ID,
				fileName: item.FileName,
				folderName: item.folderName,
				fileTypeId: item.FileTypeRecID,
				indexTypeName: item.FileIndexType,
				status: item.IsActive,
				details: item.Descr,
				url: item.URL,
			})) as IndexHistoryItemDetailed[];
		}),
		catchError(error => {
			console.error('Error fetching index history for an individual item:', error);
			return of([]); // fallback: empty array
		}));
	}


	public getNotesFileUrl(importId: number): Observable<string | null> 
	{
		const url = this.ajaxService.getBaseOfApi() + INDEX_POSTUPLOAD_REMARKS + importId + '/' + this.viewScopeService.getCurrentOpertaingUserId().toString();
		return this.ajaxService.getData(url).pipe(
			map((response: any) => 
			{
				return Array.isArray(response) && response.length > 0 && response[0].Column1 ? response[0].Column1 : null;
			}),
			catchError(error => 
			{
				console.error('Error fetching notes file URL:', error);
				return of(null);
			})
		);
	}


	public getAssignmentHistory(importId : number): Observable<AssignedValuesItem[]> 
	{
		const url = this.ajaxService.getBaseOfApi() + INDEX_ASSIGNMENTS_PRINT + importId + '/' + this.viewScopeService.getCurrentOpertaingUserId().toString();
		return this.ajaxService.getData(url).pipe(map((response: any) => {
			return (response || []).map((item: any) => ({
				IndexSectionRecID : item.IndexSectionRecID,
				SectionNumber : item.SectionNumber,
				SectionName : this.dirServ.isRtl() ? item.SectionName_HE : item.SectionName_EN,
			})) as AssignedValuesItem[];
		}),
		catchError(error => {
			console.error('Error fetching index history for an individual item:', error);
			return of([]); // fallback: empty array
		}));
	}

	public reloadIndexImport(importId: number)
	{
		const url = this.ajaxService.getBaseOfApi() + INDEX_RELOAD_REQUEST;
		const payload = JSON.stringify({
			"CustomerRecID" : this.viewScopeService.getCurrentCustomer(),
			"Import_ID"	: importId,
			"UserRecID" 	: this.viewScopeService.getCurrentOpertaingUserId()
		});
		console.log('Reload index payload:', payload);

		return this.ajaxService.updateObjectData(url,payload);
	}
}
